import React, { cloneElement } from 'react';
import Routes from './routes'
import './Global.css';
import {useState, useEffect} from "react"

export default function App() {

  const [loaded,setLoaded] = useState(false);

  useEffect(() => {

    const handleLoad = async () => setLoaded(true) 

    if(document.readyState == "complete") {
      handleLoad();
    } else {
      window.addEventListener("load", handleLoad);
      return () => window.removeEventListener("load",handleLoad);
    }
    
  },[])

  return (
    <div style={{opacity:loaded ? 1 : 0, transition:"opacity 0.3s"}}>
      {!loaded && (

        <div style={{display:"flex", flexDirection:"column",alignItems:"center",position:"absolute",top:"40%",right:"50%"}}>
          <span className='spinner'/>
          <h3>Carregando</h3>
        </div>

      )}
      <Routes/>
    </div>
        
    )
    

}
